<div class="ui-grid-cell-contents">
  <sk-iris-user
    class="user-as-list-option"
    [userId]="value()"
    [noUserLabel]="'label.NotSet'"
    avatarSize="sm"
  ></sk-iris-user>
</div>
